export default __webpack_public_path__ + "static/media/timer.6e7b6557.svg";